import { render, staticRenderFns } from "./relatedAdd.vue?vue&type=template&id=39f17e9a&scoped=true"
import script from "./relatedAdd.vue?vue&type=script&lang=js"
export * from "./relatedAdd.vue?vue&type=script&lang=js"
import style0 from "./relatedAdd.vue?vue&type=style&index=0&id=39f17e9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f17e9a",
  null
  
)

export default component.exports